export default __webpack_public_path__ + "static/media/Speed Queen@2x.33bd4ebc.png";